export const returnToCustomerHub = (embedded: boolean) => {
  window.postMessage({ closeApplicationForm: true }, '*');

  if (window?.webkit?.messageHandlers?.CustomerHub) {
    window.webkit.messageHandlers.CustomerHub.postMessage({
      type: 'navigated-close',
    });
    return;
  }

  const target = embedded ? window.parent : window;
  target.postMessage(
    {
      type: 'transition-to',
      to: 'CustomerHubMyAccounts',
      target: 'customerHub',
    },
    '*'
  );
};
